// extracted by mini-css-extract-plugin
export default {"page":"App_page__23xJz","flareAnimation":"App_flareAnimation__sRh37","shine":"App_shine__TufZR"};